<template>
    <a-popover
        v-model:open="visible"
        :overlay-style="popoverStyle"
        trigger="click"
        :key="`${posX}-${posY}`"
        :getPopupContainer="getPopupContainer"
    >
        <template #content>
            <div class="popover-content">
                <button class="close-btn" @click="closePopover" title="Fechar">
                    <i class="fas fa-times" aria-hidden="true"></i>
                </button>
                <p :title="featureData.name || ''" style="cursor: default;">
                    <strong>{{ featureData.acronym }}</strong>
                </p>
                <div class="buttons">
                    <a-button @click="openModal('services')" title="Serviços e Atividades">
                        <i class="fas fa-briefcase" aria-hidden="true" style="margin-right: 5px"></i>
                        Serviços e Atividades
                    </a-button>
                    <a-button @click="openModal('usos-solo')" title="Usos do Solo">
                        <i class="fas fa-seedling" aria-hidden="true" style="margin-right: 5px"></i>
                        Usos do Solo
                    </a-button>
                    <a-button @click="openModal('ocupacoes-solo')" title="Ocupações do Solo">
                        <i class="fas fa-building" aria-hidden="true" style="margin-right: 5px"></i>
                        Ocupações do Solo
                    </a-button>
                    <a-button @click="openModal('street')" title="Street View">
                        <i class="fas fa-map-marked-alt" aria-hidden="true" style="margin-right: 5px"></i>
                        Street View
                    </a-button>
                </div>
            </div>
        </template>
        <div ref="anchor" :style="anchorStyle"></div>
    </a-popover>

    <ModalsContainer />
</template>

<script setup>
import {ref, computed, defineExpose, markRaw, defineAsyncComponent, watch, onBeforeUnmount} from 'vue'
import {ModalsContainer, useModal} from "vue-final-modal";

import DefaultFrame from "../../Components/DefaultFrame.vue";
const modalKey = ref(0)
const currentRoute = ref()
const frame = markRaw(DefaultFrame)

const emits = defineEmits(['hide'])

const { open, destroy } = useModal({
    keepAlive: true,
    component: defineAsyncComponent(() => import('../../Components/ModalDragResize.vue')),
    attrs: {
        component: frame,
        componentProps: {
            route: currentRoute
        },
        onClosed: () => {
            visible.value = true
        },
        w: 1000,
        h: 800,
        y: 10
    },
})

const visible = ref(false)
const featureData = ref({})
const posX = ref(0)
const posY = ref(0)

const anchor = ref(null)

const anchorStyle = computed(() => ({
    position: 'fixed',
    top: `${posY.value}px`,
    left: `${posX.value}px`,
    width: '1px',
    height: '1px',
    zIndex: 1000,
}))

const popoverStyle = computed(() => ({
    zIndex: 1001,
}))

function openPopover(data, pixelPos) {
    if (
        visible.value &&
        posX.value === pixelPos[0] &&
        posY.value === pixelPos[1]
    ) {
        featureData.value = { ...data }
        return
    }

    if (visible.value) {
        visible.value = false
        setTimeout(() => {
            featureData.value = { ...data }
            posX.value = pixelPos[0]
            posY.value = pixelPos[1]
            visible.value = true
        }, 10)
    } else {
        featureData.value = { ...data }
        posX.value = pixelPos[0]
        posY.value = pixelPos[1]
        visible.value = true
    }
}

onBeforeUnmount(() => {
    destroy()
})

function closePopover() {
    visible.value = false
}

watch(visible, (newVal, oldVal) => {
    if (oldVal === true && newVal === false) {
        emits('hide')
    }
})
const openModal = (type) => {
    let route = ''

    switch (type) {
        case 'services':
            route = `/viabilidade/services/${featureData.value.id}?longitude=${featureData.value.longitude}&latitude=${featureData.value.latitude}&property-id=${featureData.value.propertyId ?? ''}`
            break;

        case 'usos-solo':
            route = `/viabilidade/usos-solo/${featureData.value.id}?type=${type}`
            break;

        case 'ocupacoes-solo':
            route = `/viabilidade/ocupacoes-solo/${featureData.value.id}?type=${type}`
            break;

        case 'street':
            route = `/street-view/${featureData.value.longitude}/${featureData.value.latitude}`
            break;
    }

    currentRoute.value = route
    modalKey.value++
    closePopover()
    open()
}

const updatePopoverPosition = (pixel) => {
    posX.value = pixel[0]
    posY.value = pixel[1]
}

const getPopupContainer = () => document.getElementById('map')

defineExpose({ openPopover, closePopover, updatePopoverPosition })
</script>

<style scoped>
.buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
}

.popover-content {
    position: relative;
    padding-right: 24px; /* espaço para o botão fechar */
}

.close-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    padding: 2px 6px;
    line-height: 1;
    transition: color 0.2s;
}

.close-btn:hover {
    color: #000;
}
</style>
